import { ScrollingImagesProps } from './scrolling-images.type';

export const ScrollingImages = ({ className }: ScrollingImagesProps) => {
  return (
    <div className={`relative h-full overflow-hidden ${className}`}>
      <div className="scrolling-image" />
      <div className="scrolling-gradient" />
    </div>
  );
};
